window.onload = (event) => {
    console.log('Page Loaded');

    import("./Index.jsx").then((module) => {
        console.log('APP Loaded');
        module.default();
    });
};